import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import DashboardLayout from "./components/DashboardLayout";
import EkycOverview from "./pages/EkycOverview";
import CaseDetails from "./pages/CaseDetails";
import IonAsiaReports from "./pages/IonAsiaReports";
import ProtectedRoute from "./components/ProtectedRoute";
import QuickVerification from "./pages/QuickVerification";


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/quick-verification" element={<QuickVerification />} />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <DashboardLayout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/ekyc" replace />} />
          <Route path="ekyc" element={<EkycOverview />} />
          <Route path="ekyc/:caseId" element={<CaseDetails />} />
          <Route path="reports" element={<IonAsiaReports />} />
        </Route>

        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
